import angular from 'angular';

import promoConfirmationTool from './promoConfirmationTool.component';

export default angular.module('app.promo.confirmationTool', [])
.component('promoConfirmationTool', promoConfirmationTool);
